import React from "react";
import "./ProgressIndicator.css";
import classNames from "classnames";

interface Props {
  state: number;
  bubbleNum: number;
  displayNum: boolean;
  description: string;
  activeState: boolean;
  previousState: boolean;
  inactiveState: boolean;
}

const StatusBubble = (props: Props) => {
  return (
    <div className="status-bubble-container">
      <div
        className={
          props.state === props.bubbleNum
            ? "status-bubble-active"
            : "status-bubble-inactive"
        }
      >
        {props.displayNum && (
          <p className="status-bubble-text">{props.bubbleNum}</p>
        )}
      </div>
      <p
        className={classNames({
          "progress-text-active":
            props.state === props.bubbleNum && props.activeState,
          "progress-text-previous":
            props.state > props.bubbleNum && props.previousState,
          "progress-text-inactive":
            props.state < props.bubbleNum && props.inactiveState,
        })}
      >
        {props.description}
      </p>
    </div>
  );
};

export default StatusBubble;
